import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';
import withRouter from 'react-router/lib/withRouter';
import compose from 'recompose/compose';

import { t } from '../../modules/infra/i18n';
import withOwnerTypeAndId from '../common/hoc/withOwnerTypeAndId';
import Icon, { GLYPHS } from '../common/icon';
import RoleAwareLink from '../common/RoleAwareLink';

class HeaderDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpened: false,
    };
  }

  onClick = () => {
    this.setState({ isOpened: false });
  };

  toggleDropdown = (e) => {
    e.preventDefault();
    this.setState({ isOpened: !this.state.isOpened });
  };

  handleClickOutside = () => {
    if (this.state.isOpened) {
      this.setState({ isOpened: false });
    }
  };

  render() {
    const dropdownClass = classNames('c-header-primary__dropdown js-toggle', {
      'is-active': this.state.isOpened,
    });

    const dropdownListClass = classNames('c-header-primary-menu', {
      'is-active': this.state.isOpened,
    });

    return (
      <div className="c-header-primary__item u-position-relative">
        <button
          data-automation-id="memberships-nav-button"
          type="button"
          className={dropdownClass}
          onClick={this.toggleDropdown}
        >
          <div className="c-heading c-heading--light u-mr-- u-visible-inline-block-for-medium-and-up">
            {this.props.title || t('memberships:navigation.memberships')}
          </div>
          <Icon glyph={GLYPHS.arrowCircle} size="medium" className="c-dropdown-icon" />
        </button>
        <div className={dropdownListClass} data-automation-id="memberships-nav-list">
          <ul className="c-separator-list">
            <li className="c-separator-list__item c-separator-list__item--header">
              <RoleAwareLink
                to="/memberships"
                onlyActiveOnIndex
                className="c-header-primary-menu__link"
                onClick={this.onClick}
                activeClassName="c-header-primary-menu__link is-active"
              >
                {t('memberships:navigation.memberships')}
              </RoleAwareLink>
            </li>
            <li className="c-separator-list__item c-separator-list__item--header">
              <RoleAwareLink
                to="/memberships/subscriptions"
                onlyActiveOnIndex
                className="c-header-primary-menu__link"
                onClick={this.onClick}
                activeClassName="c-header-primary-menu__link is-active"
              >
                {t('memberships:navigation.subscriptions')}
              </RoleAwareLink>
            </li>
            <li className="c-separator-list__item c-separator-list__item--header">
              <RoleAwareLink
                to="/memberships/invoices"
                onlyActiveOnIndex
                className="c-header-primary-menu__link"
                onClick={this.onClick}
                activeClassName="c-header-primary-menu__link is-active"
              >
                {t('memberships:navigation.invoices')}
              </RoleAwareLink>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
HeaderDropdown.propTypes = {
  title: PropTypes.string.isRequired,
  ownerType: PropTypes.string.isRequired,
};

export default compose(withRouter, withOwnerTypeAndId, onClickOutside)(HeaderDropdown);
